module.exports = __webpack_public_path__ + "img/4.b66069a1.jpg";